
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowTopRight as ObiArrowTopRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-top-right.js';
 
 
 

 
 export const ObiArrowTopRight = createComponent({
   react: React,
   tagName: 'obi-arrow-top-right',
   elementClass: ObiArrowTopRightElement,
   events: {
     
   }
  });
 
 